module.exports = __webpack_public_path__ + "img/Expertise Icon (2).3c1275db.svg";